type SpacingSize = "xxs" | "xs" | "s" | "default" | "m" | "l" | "xl" | "xxl";

interface SpacerProps {
  size?: SpacingSize;
}

const spacing: Record<SpacingSize, number> = {
  xxs: 4,
  xs: 8,
  s: 16,
  default: 24,
  m: 32,
  l: 42,
  xl: 60,
  xxl: 96,
};

/** Adds vertical space between components */
export function Spacer({ size = "default" }: SpacerProps) {
  return <div style={{ height: spacing[size] }} />;
}
